import type { CreatePaymentLinkOptions } from '../types';
import { encodePaymentData } from './encoding';

/**
 * Create a shareable payment link with encoded payment data
 * 
 * @example
 * const link = createPaymentLink({
 *   to: '0x742d35Cc6634C0532925a3b844Bc9e7595f0bEb',
 *   amount: '0.50',
 *   memo: 'Coffee donation',
 *   baseUrl: 'https://myblog.com'
 * });
 * // Returns: https://myblog.com?x402=eyJ0b...
 */
export function createPaymentLink(options: CreatePaymentLinkOptions): string {
  const encoded = encodePaymentData(options);
  
  if (options.baseUrl) {
    const url = new URL(options.baseUrl);
    
    if (options.useHash) {
      url.hash = `x402:${encoded}`;
    } else {
      url.searchParams.set('x402', encoded);
    }
    
    return url.toString();
  }
  
  // No base URL - just return the encoded data with query param
  return `?x402=${encoded}`;
}

/**
 * Create a payment link for the current page
 */
export function createPaymentLinkHere(data: Omit<CreatePaymentLinkOptions, 'baseUrl'>): string {
  if (typeof window === 'undefined') {
    return createPaymentLink(data);
  }
  
  return createPaymentLink({
    ...data,
    baseUrl: window.location.origin + window.location.pathname,
  });
}

